import $ from 'jquery';
import ajax from 'util/ajax';
import { initAutosubmit } from 'util/autosubmit';
import {
  $body,
  $window,
  jqGetElemByCmpName,
  jqGetElemById,
  getRelativeUrl,
  jqOffOn,
  userIsAuthenticated,
} from 'util/global';
import * as latex from 'util/latex';
import { crop } from 'util/ui';
import { errorModalHandler } from 'app/error_modal';
import { initGenericControllers } from 'app/generic_controllers';

const contentModal = {
  /** @type {Array.<string>} */
  urlStack: [],
};

const { vkey } = window;

// modal solvables
// --------------------------------------------------

var $newsfeed_modal, // the entire modal container
  $newsfeed_modal_solvable_content, // the modal solvable's container
  $newsfeed_modal_note_content, // the modal note's container
  $current_open_feed_item = null, // the feed item that triggered the open solvable
  open_modal_is_solvable = false, // true if current feed item is a solvable
  open_modal_is_set = false, // true if current feed item is a set
  open_modal_is_refreshable = false, // true if current feed item should be reloaded after closing modal
  newsfeed_modal_has_error = false, // flag for errors when loading the modal
  newsfeed_modal_request = null, // modal XMLHttpRequest object
  newsfeed_stacked_views = [], // push modals to a stack when open modals within modals
  newsfeed_modal_parent_data, // parent view data
  modal_solvable_vkey = 'assessment_modal_public_solvable_component',
  modal_note_vkey = 'discussions_modal_single_component',
  modalHasBeenClosedByUser = false;

/*
    Preload variables:
    These are key-value stores used to manage preloading content where the key is the item's
    modal url. When a request is started, `nf_preload_flags` is set, and when it is finished
    `nf_preload_content` is set. Therefore, if `nf_preload_flags` is set but
    `nf_preload_content` isn't, then the request is in progress.
*/
var /** Set when a preload request is started: i.e. nf_preload_flags[modalUrl] = true */
  nf_preload_flags = {},
  /** Set when a preload request is complete: i.e. nf_preload_content[modalUrl] = response */
  nf_preload_content = {};

// handle loading solvables for individual feed items
var newsfeed_modal_events = function () {
  var $feed_item = $(this),
    data = $feed_item.data(),
    url = data.modalUrl || null;

  $feed_item.addClass('inited');

  // if there's no modal url or the modal container is missing, open the
  // feed item the old-fashioned way
  if (!$newsfeed_modal || $newsfeed_modal.length === 0 || url === null) {
    return;
  }

  // trigger the modal when clicking anything .sovlable-link
  jqOffOn($feed_item.find('.modal-link'), 'click', e => {
    // ...unless they're pushing ctrl or cmd or something
    if (!e.metaKey) {
      e.preventDefault();

      var $parent_item = $feed_item.parents('.nf-feed-item');
      if ($parent_item.data('just-dragged')) {
        $parent_item.removeData('just-dragged');
        return;
      }

      $current_open_feed_item = $feed_item;
      newsfeed_feeditem_modal_open(data);
      open_modal_is_solvable = data.isSolvable;
      open_modal_is_set = data.isSet;
      open_modal_is_refreshable = data.refreshable;
      $newsfeed_modal.addClass('loading');
      $newsfeed_modal.removeClass('loaded');

      if (open_modal_is_solvable) {
        $newsfeed_modal.addClass('solvable').removeClass('note set');
      } else if (open_modal_is_set) {
        $newsfeed_modal.addClass('set').removeClass('solvable note');
      } else {
        $newsfeed_modal.addClass('note').removeClass('solvable set');
      }

      // use for preloaded content
      if (nf_preload_content[url]) {
        newsfeed_modal_load_from_preload(url, data);

        // request new modal content
      } else {
        // if preloading is in progress, wait for preloading to finish
        if (nf_preload_flags[url]) {
          var preload_poll = setInterval(function () {
            if (nf_preload_content[url]) {
              clearInterval(preload_poll);
              newsfeed_modal_load_from_preload(url, data);
            }
          }, 200);

          // load item normally
        } else {
          newsfeed_modal_request = $.ajax({
            url: url,
            data: {
              force_full_page: 'true',
            },
            success: newsfeed_modal_loaded,
            error: newsfeed_modal_error,
          });
        }
      }
    }
  });
};

// handle successfully loading a solvable
var newsfeed_modal_loaded = function (response) {
  newsfeed_modal_request = null;

  if (response.redirect) {
    window.location = response.redirect;
  } else {
    $newsfeed_modal.toggleClass('loading loaded');

    // update url
    var contentUrl = newsfeed_modal_parent_data.modalUrl
      .replace('/modal', '')
      .replace('/_modal', '')
      .replace('-thread', '/thread');

    if (contentUrl && window.history.pushState) {
      var currentUrl = getRelativeUrl();
      if (contentUrl !== currentUrl) {
        var stateObject = {
          modalContent: true,
        };
        if (newsfeed_modal_parent_data.isPost || newsfeed_modal_parent_data.isSolvable) {
          stateObject.isPostOrSolvable = true;
          if (window.history.state && window.history.state.isPostOrSolvable) {
            window.history.replaceState(stateObject, '', contentUrl);
          } else {
            contentModal.urlStack.push(currentUrl);
            window.history.pushState(stateObject, '', contentUrl);
          }
        } else {
          contentModal.urlStack.push(currentUrl);
          window.history.pushState(stateObject, '', contentUrl);
        }
      }
    }

    if (open_modal_is_solvable) {
      $newsfeed_modal_solvable_content.html(response);
      $newsfeed_modal_note_content.html('');
      newsfeed_modal_check_for_preloadable_content();
    } else {
      $newsfeed_modal_note_content.html(response);
      initGenericControllers($newsfeed_modal_note_content);
      $newsfeed_modal_solvable_content.html('');
      newsfeed_modal_check_for_preloadable_content();
    }

    latex.updateMathjax($newsfeed_modal);
    latex.checkOverflow($newsfeed_modal);

    // attach solvable events -- in solvables.js
    if (open_modal_is_solvable) {
      require('app/solvables')[modal_solvable_vkey]($newsfeed_modal_solvable_content);
    } else {
      require('app/discussions')[modal_note_vkey]($newsfeed_modal_note_content);
    }
  }
};

// handle errors
var newsfeed_modal_error = function (xhr, status) {
  if (status !== 'abort') {
    if (xhr.status === 404) {
      newsfeed_modal_request = null;
      newsfeed_feeditem_modal_close();

      // remove 404ing component
      $('.cmp_' + $current_open_feed_item.data('param_key') + '_id')
        .parents('.nf-feed-item')
        .remove();
    } else {
      newsfeed_modal_has_error = true;
      newsfeed_modal_request = null;
      newsfeed_feeditem_modal_close();
      errorModalHandler(xhr);
    }
  }
};

// handle opening the modal
var newsfeed_feeditem_modal_open = function (data) {
  if (open_modal_is_set && $newsfeed_modal.is(':visible')) {
    newsfeed_stacked_views.push({
      view: $newsfeed_modal.clone(),
      data: newsfeed_modal_parent_data, // get previous view's data
      current_open_feed_item: $current_open_feed_item,
    });
    $newsfeed_modal.addClass('sub-view');
  }

  newsfeed_modal_parent_data = data; // save for later

  // show the modal
  $newsfeed_modal.show().addClass('clearfix');
  crop();

  // hide on esc
  jqOffOn($window, 'keydown.nfmodal', e => {
    if (e.which === 27) {
      newsfeed_feeditem_modal_close();
    }
  });
};

/**
 * Handles closing the modal
 * @param {boolean} [args.backButtonClicked] Should be "true" if the modal is closed by
 *                                           the browser back button
 */
var newsfeed_feeditem_modal_close = function (args) {
  args = args || {};

  var preventBackwardNav = false;

  if (newsfeed_modal_request !== null) {
    newsfeed_modal_request.abort();
    newsfeed_modal_request = null;
    preventBackwardNav = true;
  }

  // reload the feed item
  if (
    !newsfeed_modal_has_error &&
    $current_open_feed_item &&
    $current_open_feed_item.data('refreshable')
  ) {
    var all_data = $current_open_feed_item.data(),
      data = {
        version: all_data.version,
        deferred: all_data.deferred,
        page_key: all_data.page_key,
        cmp_url: all_data.cmp_url,
        individual_reload: all_data.individual_reload,
        param_key: all_data.param_key,
      };

    // handle 404s by removing the feed item
    var refresh_ajax = new ajax(data.page_key);
    refresh_ajax.error = function (response) {
      if (response.status === 404) {
        // re-select the component based on the param key.
        $('.cmp_' + data.param_key + '_id')
          .parents('.nf-feed-item')
          .remove();
      } else if (response.status > 0) {
        errorModalHandler(response);
      }
    };
    setTimeout(function () {
      refresh_ajax.get(data.cmp_url, data);
    }, 100);
  }

  // reset url
  if (
    !args.backButtonClicked &&
    window.history &&
    window.history.pushState &&
    !preventBackwardNav
  ) {
    modalHasBeenClosedByUser = true;
    window.history.back();
  }

  if (newsfeed_stacked_views.length) {
    const parentView = newsfeed_stacked_views.pop();
    $current_open_feed_item = parentView.current_open_feed_item;
    $newsfeed_modal.replaceWith(parentView.view);
    $newsfeed_modal = jqGetElemById('nf-feeditem-modal').removeClass('inited');
    open_modal_is_set = true;
    initAutosubmit();
    newsfeed_feeditem_modal($newsfeed_modal);
    initGenericControllers($newsfeed_modal);
  } else {
    // reset everything else
    $current_open_feed_item = null;
    newsfeed_modal_has_error = false;
    $newsfeed_modal.hide().removeClass('clearfix');
    crop(false);
    $window.off('keydown.nfmodal');
  }
};

// initialize the modal
var newsfeed_feeditem_modal = function ($root = $body, skipEvents) {
  $newsfeed_modal = jqGetElemById('nf-feeditem-modal');
  $newsfeed_modal_solvable_content = jqGetElemByCmpName(modal_solvable_vkey);
  $newsfeed_modal_note_content = jqGetElemByCmpName(modal_note_vkey);

  if (skipEvents !== true && $newsfeed_modal.length > 0) {
    $root.find('.modal-feed-item').each(newsfeed_modal_events);
    if (!$newsfeed_modal.hasClass('inited')) {
      $newsfeed_modal.addClass('inited');
      $newsfeed_modal.on('click', function (e) {
        if (e.target === $newsfeed_modal[0]) {
          newsfeed_feeditem_modal_close();

          // if set or subview
        } else if (open_modal_is_set || newsfeed_stacked_views.length) {
          // clicking content divs should close (different style than normal modal)
          const shouldCloseCheck =
            e.target === $newsfeed_modal_solvable_content[0] ||
            e.target === $newsfeed_modal_note_content[0] ||
            e.target === jqGetElemById('setview-header')[0];
          if (shouldCloseCheck) {
            newsfeed_feeditem_modal_close();
          }
        } else if ($(e.target).hasClass('refresh')) {
          e.preventDefault();
          $(e.target).parents('form').submit();
          setTimeout(function () {
            window.location.href = window.location.href;
          }, 1000);
        }
      });
      $newsfeed_modal.on('click', '.close-modal', function (e) {
        e.preventDefault();
        newsfeed_feeditem_modal_close();
      });
      $('#nf-modal-close').on('click', newsfeed_feeditem_modal_close);
    }
  }
};

/**
 * Preload a given feed item, cached based on the component url
 * @param {JQuery} $feeditem
 */
var newsfeed_modal_preload_feeditem = function ($feeditem) {
  if ($feeditem.length === 0) {
    return;
  }

  var data = $feeditem.data(),
    url = data.modalUrl;

  // guard against preloading the same component twice
  if (url && nf_preload_flags[url] !== true) {
    // set the preload flag
    nf_preload_flags[url] = true;

    // send preload request
    $.get(url, {
      is_preloading: true,
      force_full_page: true,
    })
      .then(function (response) {
        // success: save the response
        nf_preload_content[url] = response;
      })
      .fail(function () {
        // error: clear the flag
        nf_preload_flags[url] = false;
      });
  }
};

/**
 * Find preloadable targets (i.e. Sets next/prev buttons)
 */
var newsfeed_modal_check_for_preloadable_content = function () {
  var $targets = $newsfeed_modal_solvable_content
    .add($newsfeed_modal_note_content)
    .find('.modal-target');
  if ($targets.length) {
    $targets.each(function () {
      newsfeed_modal_preload_feeditem($(this));
    });
  }
};

/**
 * Handle using preloaded content
 * @param  {String} url - original modal url for preloaded content
 * @param  {Object} data - data object from modal trigger
 */
var newsfeed_modal_load_from_preload = function (url, data) {
  // send the preloaded content to the modal loaded handler to display the content
  // and add any event handlers
  newsfeed_modal_loaded(nf_preload_content[url]);

  // delete preload content and flag
  delete nf_preload_content[url];
  delete nf_preload_flags[url];

  // if new content is a solvable and user is logged in, send a request
  // to .../start_attempt/
  if (data.isSolvable && userIsAuthenticated) {
    const startAttemptUrl = url.replace('?', 'start_attempt/?');
    data.version = window.VERSIONS[data.page_key] || 1;
    $.post(startAttemptUrl, data).fail(errorModalHandler);
  }
};

/**
 * Preload the first feed item in a container
 */
contentModal.preloadFirstItem = function ($container) {
  newsfeed_modal_preload_feeditem($container.find('.modal-feed-item').first());
};

/**
 * This handler is hooked up to the main popstate handler.
 * When it actually does anything it should return true and this will
 * cancel whatever the main handler does. Otherwise, it should return false.
 * @returns {boolean}
 */
contentModal.popstateHandlerHook = function () {
  if (modalHasBeenClosedByUser) {
    modalHasBeenClosedByUser = false;
    contentModal.urlStack.pop();
    // no need to do anything else
    return true;
  }
  // check if browser back button has been clicked
  var urlStack = contentModal.urlStack;
  if (urlStack.length > 0 && getRelativeUrl() === urlStack[urlStack.length - 1]) {
    contentModal.urlStack.pop();
    newsfeed_feeditem_modal_close({
      backButtonClicked: true,
    });
    return true;
  }
  return false;
};

// exports
// --------------------------------------------------

contentModal.modal_events = newsfeed_modal_events;
contentModal.feeditem_modal = newsfeed_feeditem_modal;
contentModal.feeditem_modal_close = newsfeed_feeditem_modal_close;

module.exports = contentModal;
